import { useMemo } from 'react';
import { DrawApi } from '@apply/api';
import { applicationInsights } from '../ApplicationInsights';
import { BfiDataGrid, Column, CustomStore } from '../common/SharedComponents';
import { SearchResponse } from '@apply/api/src/api/bfiApi';
import { feedbackIcons } from '../common/functions/feedbackIcons';
import { IFeedbackGrid } from '@apply/api/src/api/DrawApi';
import Query from 'devextreme/data/query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ColumnCellTemplateData } from 'devextreme/ui/data_grid';

const FeedbackTable = () => {
    const drawApi = new DrawApi.DrawApi(applicationInsights);
    const customStore = useMemo(
        () =>
            new CustomStore({
                key: 'feedbackDate',
                load: async (options) => {
                    const response: SearchResponse<IFeedbackGrid[]> = await drawApi.getAllFeedback();

                    if (options.filter) {
                        response.result.data = Query(response.result.data)
                            .filter(options.filter)
                            .select('feedBackCategory', 'feedbackDate', 'feedbackUsername', 'comment')
                            .toArray();
                    }

                    return response.result;
                },
            }),
        []
    );

    const onFeedbackCellRender = (e: ColumnCellTemplateData) => {
        const iconData = feedbackIcons.find((icon) => icon.id === e.data.feedbackCategory);
        if (!iconData) return;

        return (
            <div className='feedback-table-icons'>
                <img
                    src={`/images/${iconData.imageName}`}
                    alt={iconData.title}
                    style={{ width: '40%' }}
                    className='feedback-icon-image'
                />
            </div>
        );
    };

    return (
        <BfiDataGrid
            dataStore={customStore}
            applicationInsights={applicationInsights}
            remoteOperations={true}
        >
            <Column
                dataField='feedBackCategory'
                caption='Level'
                cellRender={onFeedbackCellRender}
                width={60}
            />
            <Column
                dataField='feedbackDate'
                caption='Date'
                dataType='date'
                width={120}
                alignment='center'
            />
            <Column
                dataField='feedbackUsername'
                caption='Name'
                width={320}
                alignment='center'
            />
            <Column
                dataField='comment'
                caption='Comment'
                dataType='string'
            />
        </BfiDataGrid>
    );
};

export default FeedbackTable;
